import { Pedestrian } from "../Model/Pedestrian";
import { v4 as v4uuid } from "uuid";
import { getCurrentUser } from "./session";
import { Third } from "../Model/Third";
import { Query } from "../Model/Query";
export class PedestrianService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findByDiligenceNumber(diligenceId) {
        if (diligenceId) {
            const response = await this.apiService.get('pedestrian/' + diligenceId);
            if (!response.ok) {
                throw new Error(`Error al obtener el peatón.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener witnessId.`);
        }
    }
    async findThirds(opts) {
        var _a, _b;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.diligenceId) {
                query.addFilter('diligence_id', [opts.filters.diligenceId]);
            }
            if ((_b = opts.filters) === null || _b === void 0 ? void 0 : _b.thirdId) {
                query.addFilter('third_id', [opts.filters.thirdId]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`pedestrian/thirds?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(third => new Third(third).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async findOne(pedestrianId, diligenceId) {
        if (pedestrianId) {
            const response = await this.apiService.get('pedestrian/' + diligenceId + '/third_id/' + pedestrianId);
            if (!response.ok) {
                throw new Error(`Error al obtener el peaton`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener pedestrianId`);
        }
    }
    async savePedestrian(pedestrian) {
        if (pedestrian) {
            const response = await this.apiService.post('pedestrian', pedestrian);
            if (!response.ok) {
                throw new Error(`Error al guardar el peatón.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener peatón.`);
        }
    }
    async createPedestrian(thirdId, diligenceId) {
        if (thirdId && diligenceId) {
            const dateNow = new Date();
            const complainant = new Pedestrian({
                id: v4uuid(),
                diligenceNumber: diligenceId,
                pedestrianThirId: thirdId,
                manifestation: " ",
                dateCreated: dateNow.toString(),
                optionalPart: " ",
                medicalHistory: " ",
                present: " ",
                userId: getCurrentUser().id,
                third_name: null
            });
            const response = await this.apiService.post('pedestrian', complainant.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar el peatón Global de una diligencia`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el peatón Global`);
        }
    }
    async deletePedestrian(thirdId) {
        if (thirdId) {
            const response = await this.apiService.get('pedestrian/delete/' + thirdId);
            if (!response.ok) {
                throw new Error('Error al eliminar el peatón');
            }
        }
    }
}
